// Faro tracing is disabled for the CRM frontend. This stub keeps the previous
// API surface so application code can continue to import the helpers without
// pulling in the heavy Grafana Faro packages that were breaking builds.

export function initializeFaroTracing() {
  if (process.env.NODE_ENV !== 'production') {
    console.debug('[Tracing] Faro integration disabled for crm-frontend');
  }
}

export function addBusinessContext() {
  // Intentionally left blank while tracing is disabled
}

export function createBusinessSpan(name, operation) {
  return typeof operation === 'function' ? operation() : undefined;
}

export default function TraceProvider({ children }) {
  return children;
}
